import React, { useEffect, useState } from "react";
import Header from "../../../common/header/header";
import Nav from "../nav";
import { TextInput, Modal } from "@mantine/core";
import { useLocation } from "react-router-dom";

const SalaryTax = () => {
  const [salary, setSalary] = useState("");
  const [tax, setTax] = useState(0);
  const [monthlySalaryAfterTax, setMonthlySalaryAfterTax] = useState(0);
  const [yearlySalaryAfterTax, setYearlySalaryAfterTax] = useState(0);
  const [opened, setOpened] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const calculateTax = (monthlySalary) => {
    const annualSalary = monthlySalary * 12;
    let taxAmount = 0;

    if (annualSalary <= 600000) {
      taxAmount = 0;
    } else if (annualSalary > 600000 && annualSalary <= 1200000) {
      taxAmount = (annualSalary - 600000) * 0.05;
    } else if (annualSalary > 1200000 && annualSalary <= 2200000) {
      taxAmount = (annualSalary - 1200000) * 0.15 + 30000;
    } else if (annualSalary > 2200000 && annualSalary <= 3200000) {
      taxAmount = (annualSalary - 2200000) * 0.25 + 180000;
    } else if (annualSalary > 3200000 && annualSalary <= 4100000) {
      taxAmount = (annualSalary - 3200000) * 0.3 + 430000;
    } else {
      taxAmount = (annualSalary - 4100000) * 0.35 + 700000;
    }

    setTax(taxAmount);
    setMonthlySalaryAfterTax(monthlySalary - taxAmount / 12);
    setYearlySalaryAfterTax(annualSalary - taxAmount);
  };

  const formatNumber = (num) => {
    return num === 0 ? "0" : Math.round(num).toLocaleString("en-PK");
  };

  const handleSalaryChange = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (!isNaN(value) && value !== "") {
      setSalary(Number(value));
      calculateTax(Number(value));
    } else {
      setSalary("");
      setTax(0);
      setMonthlySalaryAfterTax(0);
      setYearlySalaryAfterTax(0);
    }
  };

  return (
    <>
      <Header />
      <div className="row omcboxed" style={styles.navWidth}>
        <Nav nopadding={true} />
      </div>
      <div className="calculator-box container container_box">
        <div className="tax-calculator-content">
          <h1>Tax Calculator Pakistan 2024-2025</h1>
          <p>
            This is the latest tax calculator as per the 2024-2025 budget
            presented by the government of Pakistan.{" "}
            <span onClick={() => setOpened(true)}>Read Salary Tax Slab</span>
          </p>
          <TextInput
            placeholder="Enter Your Monthly Salary"
            type="text"
            value={salary ? salary.toLocaleString("en-PK") : ""}
            onChange={handleSalaryChange}
          />
        </div>
        <div className="monthly-income-value">
          <div className="value-number">
            <span>Monthly Income</span>
            <span>{formatNumber(salary * 1)}</span>
          </div>
          <div className="value-number">
            <span>Monthly Tax</span>
            <span>{formatNumber(tax / 12)}</span>
          </div>
          <div className="value-number">
            <span>Monthly Salary After Tax</span>
            <span>{formatNumber(monthlySalaryAfterTax)}</span>
          </div>
          <div className="value-number">
            <span>Yearly Income</span>
            <span>{formatNumber(salary * 12)}</span>
          </div>
          <div className="value-number">
            <span>Yearly Tax</span>
            <span>{formatNumber(tax)}</span>
          </div>
          <div className="value-number">
            <span>Yearly Income After Tax</span>
            <span>{formatNumber(yearlySalaryAfterTax)}</span>
          </div>
        </div>
      </div>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        className="salary-tax-header"
        title="Income Tax Slabs for Salaried Individuals"
        size="lg"
        centered
      >
        <p>
          As per the latest income tax regulations for the year <b>2024-2025</b>
          , the following slabs and income tax rates will be applicable for
          salaried persons:
        </p>
        <p>
          Where the taxable salary income does not exceed Rs. 600,000, the rate
          of income tax is 0%.
        </p>
        <p>
          Where the taxable salary income exceeds Rs. 600,000 but does not
          exceed Rs. 1,200,000, the rate of income tax is 5% of the amount
          exceeding Rs. 600,000.
        </p>
        <p>
          Where the taxable salary income exceeds Rs. 1,200,000 but does not
          exceed Rs. 2,200,000, the rate of income tax is Rs. 30,000 + 15% of
          the amount exceeding Rs. 1,200,000.
        </p>
        <p>
          Where the taxable salary income exceeds Rs. 2,200,000 but does not
          exceed Rs. 3,200,000, the rate of income tax is Rs. 180,000 + 25% of
          the amount exceeding Rs. 2,200,000.
        </p>
        <p>
          Where the taxable salary income exceeds Rs. 3,200,000 but does not
          exceed Rs. 4,100,000, the rate of income tax is Rs. 430,000 + 30% of
          the amount exceeding Rs. 3,200,000.
        </p>
        <p>
          Where the taxable salary income exceeds Rs. 4,100,000, the rate of
          income tax is Rs. 700,000 + 35% of the amount exceeding Rs. 4,100,000.
        </p>
      </Modal>
    </>
  );
};

const styles = {
  navWidth: {
    width: "100%",
    fontSize: "14px",
    margin: "auto",
    marginBottom: "10px",
    justifyContent: "space-between",
  },
};

export default SalaryTax;
